import Entity from './Entity';

export default class IllustrationCategory implements Entity {
  constructor(
    public id: number,
    public parentId: number | null,
    public name: string,
    public leaf: boolean,
    public illustrationCount: number,
  ) {}
}
